/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useDateTimeOptions } from "cms/fields/hooks/use-date-time-options";
import { useOnChangeDateTime } from "cms/fields/hooks/use-on-change-date-time";
import { DateTimeEdit } from "cms/fields/layout/controls/date-time";
import { SettingsFormatEdit } from "cms/fields/layout/controls/settings-format";
import { SettingsStyleEdit } from "cms/fields/layout/controls/settings-style";
import DisplaySettingsWrapper from "cms/fields/layout/display-settings-wrapper";
import Config from "data/config";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { ListItemContext } from "cms/fields/field-lists/field-list-context";

// FIXME: Styles not centralized
import "styles/react-datepicker.css";
import dayjs from "dayjs";

const STORAGE_FORMAT = Config.dates.internalFormats.time;

const TimeFieldItemEdit = () => {
    const { t } = useTranslation();

    const { name } = useContext(ListItemContext);
    const {
        disabled,
        formatOptions,
        index,
        placeholder,
        styleOptions,
        type
    } = useDateTimeOptions();
    
    const { 
        fieldValue,
        setFieldValue,
        onChangeDateTime,
        onSettingsChange,
        dateTimeString: time
    } = useOnChangeDateTime(STORAGE_FORMAT);


    const editTime = dayjs(time, Config.dates.internalFormats.time)
        .format(Config.dates.display.time);

    return (
        <div className='simplicity-composer-field-primary-layout'>
            <div className='simplicity-composer-field-primary'>
                <DateTimeEdit
                    name={name}
                    type={type}
                    value={time}
                    placeholder={placeholder}
                    onChangeDateTime={onChangeDateTime}
                />
                {/*  Provide example using format */}
                <p>Time: {time && editTime}</p>
                {/*<p>Settings: {JSON.stringify(settings, null,2)}</p>*/}

            </div>

            <DisplaySettingsWrapper>
                {/*  Reads from schema options.styleOptions */}
                {/*  records selection as value settings.style */}
                <SettingsStyleEdit
                    type={type}
                    name={name}
                    label={t("commons.displayStyle")}
                    itemLocalState={fieldValue}
                    setItemLocalState={setFieldValue}
                    disabled={disabled}
                    styleOptions={styleOptions}
                    selected={fieldValue?.settings?.style}
                    index={index}
                    update={onSettingsChange}
                />
                {/*  Reads from schema options.formatOptions */}
                {/*  records selection as value settings.format */}
                <SettingsFormatEdit
                    type={type}
                    name={name}
                    label={t("commons.displayAs")}
                    itemLocalState={fieldValue}
                    setItemLocalState={setFieldValue}
                    disabled={disabled}
                    formatOptions={formatOptions}
                    selected={fieldValue?.settings?.format}
                    index={index}
                    update={onSettingsChange}
                />
            </DisplaySettingsWrapper>
        </div>
    );
};
TimeFieldItemEdit.displayName = "TimeFieldItemEdit";
export default TimeFieldItemEdit;


/**
 * @typedef {object} TimeFieldValue
 * @property {string} date
 * @property {string} tz
 */
